export const API_KEY =
  process.env.GOOGLE_MAPS_KEY ?? "AIzaSyAQBBv_iO46risW9VzMLhvwlXkZkfDWnp8";
